import { ModelsCurveType } from '../../../api/core/models';
import { TrajectoryFunctionType } from '../../../functions/transition-targets/trajectory-function-type';

export function transitionPathTypeToCurveType(transitionPathType: TrajectoryFunctionType | undefined): ModelsCurveType {
  switch (transitionPathType) {
    case TrajectoryFunctionType.EXPONENTIAL:
      return ModelsCurveType.Exponential;
    case TrajectoryFunctionType.MANUAL:
      return ModelsCurveType.Manual;
    case TrajectoryFunctionType.LINEAR:
    default:
      return ModelsCurveType.Linear;
  }
}
